import React, { PureComponent } from 'react'
import DesignerBody from '../components/DesignerBody.js'
import CushionDesignerSteps from '../components/CushionDesignerSteps.js'
import { Redirect, Route, Switch } from 'react-router-dom'
import CushionFillingSelector from '../components/CushionFillingSelector.js'
import CushionDimensionsSelector from '../components/CushionDimensionsSelector.js'
import CushionShapeSelector from '../components/CushionShapeSelector.js'
import CushionTypeSelector from '../components/CushionTypeSelector.js'
import { DESIGNER_STEPS_FILLING_ONLY, DESIGNER_STEPS_URLS_FILLING_ONLY } from '../utils/config.js'

class FillingOnlyRouter extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <DesignerBody urls={DESIGNER_STEPS_URLS_FILLING_ONLY}>
        <CushionDesignerSteps
          steps={DESIGNER_STEPS_FILLING_ONLY}
          urls={DESIGNER_STEPS_URLS_FILLING_ONLY}
        />
        <Switch>
          <Route path={'/cd/:category/:type/:shape/:dimensions/:filling'}>
            <CushionFillingSelector />
          </Route>
          <Route path={'/cd/:category/:type/:shape/:dimensions'}>
            <CushionDimensionsSelector />
          </Route>
          <Route path={'/cd/:category/:type/:shape'}>
            <CushionShapeSelector />
          </Route>
          <Route path={'/cd/:category/:type'}>
            <div className={'cushion-designer-layout type-selector'}>
              <p className={'cushion-designer-footer-text'}>
                Welcome to the Cushion Designer, a one-of-a-kind custom cushion builder engineered
                to put ease and enjoyment at the forefront of design. Follow the step-by-step
                prompts on screen to create your custom cushion.
              </p>
              <CushionTypeSelector />
            </div>
          </Route>
          <Route path={'/cd/:category'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/cd'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
        </Switch>
      </DesignerBody>
    )
  }
}

export default FillingOnlyRouter
